import { useQuery } from '@tanstack/react-query';
import type { SubsidiaryElectionOutcomeDto } from '@signalvote/shared';
import { authService } from '../../services/authService';
import { apiJson } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';
import { FINANCE_STALE_TIME } from './queryUtils';

export type { SubsidiaryElectionOutcomeDto };

/**
 * ADR-076 (#627) — GET /api/finance/election-outcomes. The per-subsidiary won/lost admin view:
 * every campaign's terminal (Won / Lost / Withdrew) election outcome across the whole subsidiary
 * tenant DB, newest-recorded first. Platform-admin only (the server 403s otherwise) and
 * subsidiary-WIDE, so — unlike the campaign-scoped finance reads — it is deliberately NOT gated on
 * a selected campaign; the X-Subsidiary header alone scopes it.
 */
export function useSubsidiaryElectionOutcomes() {
  return useQuery({
    queryKey: queryKeys.finance.electionOutcomes(),
    queryFn: () =>
      apiJson<SubsidiaryElectionOutcomeDto[]>('/api/finance/election-outcomes', {
        error: 'Failed to fetch election outcomes',
      }),
    enabled: authService.isAuthenticated(),
    staleTime: FINANCE_STALE_TIME,
  });
}
